export default __webpack_public_path__ + "static/media/icon-ic-fail.00038f46.svg";